
import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";

import { useropen } from '../../redux/userInfo';
import { open, close, loadingflas } from '../../redux/popupSlice';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import Input from '../../component/Input';
import Button from '../../component/Button';
import Radios from '../../component/Radios';
import { getMemberinfo, regPhone, patternPwCker } from "../../utils/utils";


import * as APIS from "../../utils/service";

export default function Storetype2Write({ navigation }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const location = useLocation();

    const [memberinfos, setmemberinfos] = useState('');

    const { configdata } = useSelector(s => s.configReducer);

    useEffect(() => {
        getMemberinfo(setmemberinfos);
    }, []);

    let leavelists = configdata?.consts?.leaveOptionConsts;
    let leavechData = [];
    leavelists?.map((x, i) => {
        leavechData.push({
            names: x?.title,
            comments: x?.desc,
            values: x?.idx,
        });
    });
    console.log(leavechData);
    const [leaveOptionlist, setleaveOptionlist] = useState({});
    const [shareOption, setshareOption] = useState({});

    const [mb_id, setmb_id] = useState('');
    const [seltype, setseltype] = useState('');
    const [radio1, setradio1] = useState(0);
    const [mb_phone, setmb_phone] = useState('');

    const checkTextOrg = "사무소 운영 방침에 동의합니다"
    const [checkText, setcheckText] = useState('');
    const [checkTextErr, setcheckTextErr] = useState('');

    const [errmsg, seterrmsg] = useState(['', '']);
    const [permit_number, setpermit_number] = useState('');

    const [results, setresults] = useState(1);
    const [company, setcompany] = useState({});

    const [Arrs, setArrs] = useState([
        { titles: '상호', comments: '천억공인중개사사무소' },
        { titles: '등록번호', comments: '15315615565' },
        { titles: '대표', comments: '홍길동' },
    ]);

    useEffect(() => {
        seterrmsg(errmsg?.map((xe, ie) => ''));
    }, [permit_number, radio1]);

    useEffect(() => {
        const { compony, application } = memberinfos;
        setArrs([
            { titles: '상호', comments: application?.title },
            { titles: '등록번호', comments: application?.permit_number },
            { titles: '대표', comments: application?.ceo },
        ]);
    }, [memberinfos]);

    useEffect(() => {
        console.log("leaveOptionlist", leaveOptionlist);
    }, [leaveOptionlist]);
    const permitSearch = () => {
        if (permit_number === '') {
            seterrmsg(errmsg?.map((xe, ie) => ie === 0 ? '중개사무소 등록번호를 입력해주세요.' : xe));
            return;
        }
        dispatch(loadingflas({ loading: true }));
        //navigate('/Storeselctor');
        let sender = {
            permit_number: permit_number,
        }


        console.log(sender);
        APIS.postData('/v1/compony/find', sender).then(({ data }) => {
            console.log(data);
            if (data) {
                setresults(2);
                data.leave_option = data?.leave_option ? data?.leave_option : 1;

                setleaveOptionlist(leavechData?.find((x, i) => x?.values * 1 === data.leave_option * 1));
                setshareOption(configdata?.consts?.shareOptionConsts.find(x => x?.idx === data?.share_option * 1))
                setcompany(data);
                setArrs([
                    { titles: '상호', comments: data?.title },
                    { titles: '등록번호', comments: data?.permit_number },
                    { titles: '대표', comments: data?.ceo },
                ]);
            } else {
                setresults(1);
            }
        }).catch(({ response }) => {
            const { data } = response;
            if (data?.code === 0) {
                seterrmsg(errmsg?.map((xe, ie) => ie === 0 ? data?.msg : xe));
            }
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });
    }

    const subcompanySubmit = () => {
        dispatch(loadingflas({ loading: true }));
        //navigate('/Storeselctor');
        let sender = {
            idx: company?.idx,
        }

        console.log(sender);
        APIS.postData('/v1/compony/application', sender).then(({ data }) => {
            console.log(data);
            if (data) {
                let requestdata = {
                    title: company?.title,
                    ceo: company?.ceo,
                    permit_number: company?.permit_number,
                }
                dispatch(
                    useropen({
                        userdata: { login: true }
                    })
                );
                navigate('/StoretypeFinsub', { state: requestdata });
            }
        }).catch(({ response }) => {
            const { data } = response;
            console.log(data);
            if (data?.code === 0) {
                seterrmsg(errmsg?.map((xe, ie) => ie === 1 ? data?.msg : xe));
            }
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });
    }
    return (
        <>
            <Layout header={false}>
                <div className='normalformw1000 heightgap40'>
                    <div className="pageinfoNumbering">
                        <b>02</b>/ 02
                    </div>
                </div>
                <div className='normalform' style={{ marginTop: 20 }}>
                    <div className='normalform_title'>{memberinfos?.name}님<br />소속 사무소를 등록해 주세요.</div>

                    <div className='inputArea'>
                        <Input
                            className={`inputs`}
                            placeholder="‘-’을 포함하여 입력하세요."
                            setValue={setpermit_number}
                            value={permit_number}
                            name="mb_phone"
                            label={"중개사무소 등록번호로 검색하세요."}
                            error={errmsg[0]}
                            withButton={'검색'}
                            withButtonPress={() => {
                                permitSearch();
                            }}
                        />
                    </div>
                    {results === 1 &&
                        <div
                            style={{
                                display: 'flex', alignItems: 'flex-start', justifyContent: 'center',
                                flexDirection: 'column', gap: 10, marginTop: 20
                            }}
                        >
                            <div className='bolds fontsize16'>등록된 사무소가 없습니다.</div>
                            <div>중개사무소가 조회되지 않는다면 대표공인중개사가 회원가입 후 <span className='bolds'>사무소를 등록</span>해야 합니다.</div>
                        </div>
                    }
                    {results === 2 &&
                        <>
                            <div className='normaltableview' style={{ marginTop: 40 }}>
                                {Arrs?.map((x, i) => {
                                    return (
                                        <div key={i}>
                                            <div>{x?.titles}</div>
                                            <div>{x?.comments}</div>
                                        </div>
                                    );
                                })}
                            </div>

                            <div className='normalform_comment' style={{ marginTop: 20 }}>아래 내용을 반드시 확인해 주세요.</div>

                            <div className='substoreAgree'>
                                <div style={{ fontSize: 16 }}>사무소 운영 방침</div>
                                <div><b>임직원 AI 매칭</b> - {shareOption?.desc}</div>
                                <div><b>퇴사 후 매물장 소유</b> - {leaveOptionlist?.comments}</div>
                                <div style={{ fontWeight: 600 }}>동의하면 아래에 [{checkTextOrg}]를 정확하게 입력하세요.</div>
                                {/* <div>
                                    <Radios
                                        linetype={'checkimg'}
                                        values={radio1}
                                        setvalues={setradio1}
                                        namevalue={[
                                            { names: '동의함', values: 0 },
                                            { names: '비동의', values: 1 },
                                        ]}
                                    />
                                </div> */}
                                <div>
                                    <Input
                                        className={`inputs`}
                                        placeholder={checkTextOrg}
                                        setValue={v => {
                                            if (v != "" && v != checkTextOrg) {
                                                setcheckTextErr("입력이 잘못되었습니다. 다시 확인해주세요.")
                                            } else {
                                                setcheckTextErr("")
                                            }
                                            setcheckText(v)
                                        }}
                                        value={checkText}
                                        name="mb_phone"
                                        error={checkTextErr}
                                    />
                                </div>
                            </div>
                            {errmsg[1] !== '' &&
                                <div>
                                    <p className="input_error"><span></span>{errmsg[1]}</p>
                                </div>
                            }

                            <div className='loginbutton' style={{ marginTop: 20 }}>
                                <Button
                                    disabled={checkText !== checkTextOrg}
                                    onPress={() => {
                                        //navigate('/Storeselctor');
                                        if (checkText === checkTextOrg) {
                                            subcompanySubmit();
                                        } else {
                                            setcheckTextErr("입력이 잘못되었습니다. 다시 확인해주세요.")
                                        }
                                    }}
                                    buttonTxt={'소속 신청'}
                                />
                                {/* {company?.leave_option * 1 === 1 ?
                                    <Button
                                        disabled={radio1 * 1 === 1 ? true : false}
                                        onPress={() => {
                                            //navigate('/Storeselctor');
                                            if (radio1 === 0) {
                                                subcompanySubmit();
                                            } else {
                                                seterrmsg(errmsg?.map((xe, ie) => ie === 1 ? '위에 동의하셔야 소속 신청이 가능합니다.' : xe));
                                            }
                                        }}
                                        buttonTxt={'소속 신청'}
                                    />
                                    :
                                    <Button
                                        disabled={radio1 * 1 === 1 ? true : false}
                                        onPress={() => {
                                            //navigate('/Storeselctor');
                                            if (radio1 === 0) {
                                                subcompanySubmit();
                                            } else {
                                                seterrmsg(errmsg?.map((xe, ie) => ie === 1 ? '위에 동의하셔야 소속 신청이 가능합니다.' : xe));
                                            }
                                        }}
                                        buttonTxt={'소속 신청'}
                                    />
                                } */}
                            </div>
                        </>
                    }
                </div>
            </Layout>
        </>
    )
}

